// extracted by mini-css-extract-plugin
export default {"container":"course-list_container__ZGM9y","title":"course-list_title__UQLdE","coursesList":"course-list_coursesList__vADhT","coursesItem":"course-list_coursesItem__noLaq"};